import React, {PureComponent, ReactNode} from 'react';
import {openPopupClickable} from './clickable';
import PrizeCard from 'app/components/reusable/PrizeCard';
import InventoryItemInterface from 'app/interfaces/InventoryItemInterface';

interface Props {
    artifact?: InventoryItemInterface;
    onClick?: () => void;
}

export default class InventorySlot extends PureComponent<Props> {
    openPopup = (): void => {
        openPopupClickable(this.props.artifact);
    };

    render(): ReactNode {
        const {artifact, onClick} = this.props;

        return <PrizeCard
            artifact={artifact}
            empty={!artifact}
            hideMeta
            hideName
            onClick={onClick || this.openPopup}
            quantity={artifact?.total_inventory_items}
            showQuantityOrange
            unavailable={Boolean(artifact?.in_market)}
        />;
    }
}
